// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f68831c","455":"a96b455c","977":"36cadd65"}[chunkId] + ".chunk.js";
};